// Animated route loader — matches the inline loader in index.html so the
// transition between initial paint and lazy-route loads stays consistent.
export default function RouteLoader() {
  return (
    <div
      role="status"
      aria-label="Carregando"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-7"
      style={{
        background:
          "radial-gradient(60% 50% at 30% 30%, hsl(var(--primary) / 0.18), transparent 60%), radial-gradient(50% 45% at 70% 70%, hsl(var(--accent) / 0.16), transparent 60%), hsl(var(--background))",
      }}
    >
      <div className="relative">
        <div
          className="w-20 h-20 rounded-[1.25rem] flex items-center justify-center font-extrabold text-xl tracking-wide"
          style={{
            background: "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent)))",
            color: "hsl(var(--primary-foreground))",
            boxShadow:
              "0 0 60px hsl(var(--primary) / 0.5), 0 0 24px hsl(var(--accent) / 0.3)",
            animation: "pre-pulse 1.8s ease-in-out infinite",
          }}
          aria-hidden="true"
        >
          NR
        </div>
        <div
          className="absolute -inset-1.5 rounded-3xl border-2 border-transparent"
          style={{
            borderTopColor: "hsl(var(--primary))",
            borderRightColor: "hsl(var(--accent))",
            animation: "pre-spin 1.1s linear infinite",
          }}
          aria-hidden="true"
        />
      </div>
      <div
        className="text-2xl font-bold tracking-tight"
        style={{
          background: "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent)))",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        NickRobotic
      </div>
      <div className="inline-flex gap-1.5" aria-hidden="true">
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: "hsl(var(--primary))", animation: "pre-bounce 1.2s ease-in-out infinite" }}
        />
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: "hsl(var(--accent))", animation: "pre-bounce 1.2s ease-in-out 0.15s infinite" }}
        />
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: "hsl(var(--primary))", animation: "pre-bounce 1.2s ease-in-out 0.3s infinite" }}
        />
      </div>
    </div>
  );
}
